import type { PERMISSIONS_LOGIC } from '@/constants/common';
import { useCustomRequirementsCheck } from '@/hooks/useCustomRequirementsCheck';
import { usePermissionsCheck } from '@/hooks/usePermissionsCheck';
import {
  useProductSubTypesCheck,
  useProductsCheck
} from '@/hooks/useProductsCheck';

import type { CustomRequirementType } from './CheckRequirements.types';

/*
  This component checks for various requirements (products, product sub-types, permissions, or a custom combination of the three
  Logic prop is not required for cusom requirements as it is handled in the hook
*/
const CheckRequirements = ({
  children,
  products,
  productsSubType,
  permissions,
  custom,
  logic
}: {
  children: React.ReactNode;
  products?: string[];
  productsSubType?: string[];
  permissions?: string[] | string;
  custom?: CustomRequirementType;
  logic?: PERMISSIONS_LOGIC;
}) => {
  // Call all hooks unconditionally at the top level
  const hasProducts = useProductsCheck(products || [], logic);
  const hasProductSubTypes = useProductSubTypesCheck(
    productsSubType || [],
    logic
  );
  const hasPermissions = usePermissionsCheck(permissions || [], logic);
  const hasCustomRequirements = useCustomRequirementsCheck(custom);

  // Determine which check to use based on props (in order of priority)
  let shouldRender = true;

  if (products) {
    shouldRender = hasProducts;
  } else if (productsSubType) {
    shouldRender = hasProductSubTypes;
  } else if (permissions) {
    shouldRender = hasPermissions;
  } else if (custom) {
    shouldRender = hasCustomRequirements;
  }

  return shouldRender ? children : null;
};

export default CheckRequirements;
